import type { User } from '@chatapp-inbox/shared';

const collator = new Intl.Collator('pt-BR', { sensitivity: 'base' });

/**
 * Por nome, sem diferenciar maiúsculas nem acentos ("álvaro" entre os "a"), e por e-mail quando os
 * nomes são iguais. O servidor entrega por data de criação: a ordem da tela é decidida aqui, e o
 * cache continua como veio (outras telas leem o mesmo cache).
 */
export function sortUsers(users: readonly User[]): User[] {
  return [...users].sort(
    (a, b) => collator.compare(a.name, b.name) || collator.compare(a.email, b.email),
  );
}
